export default {"name":"knowledge-center"};